(function () {
  if (window.__fab_cp_controller_loaded) return;
  window.__fab_cp_controller_loaded = true;

  const SUPPORTED_MIME = ['image/jpeg', 'image/png', 'image/heic', 'image/heif', 'image/webp'];
  const MAX_ORIGINAL_BYTES = 25 * 1024 * 1024;

  function $(root, sel) { return root.querySelector(sel); }

  function showProgress(buyEl, label, pct) {
    const progress = $(buyEl, '[data-fab-cp-progress]');
    if (!progress) return;
    progress.hidden = false;
    const labelEl = $(buyEl, '[data-fab-cp-progress-label]');
    if (labelEl && label) labelEl.textContent = label;
    const fill = $(buyEl, '[data-fab-cp-progress-fill]');
    if (fill && typeof pct === 'number') fill.style.width = Math.max(0, Math.min(100, pct)) + '%';
  }

  function hideProgress(buyEl) {
    const progress = $(buyEl, '[data-fab-cp-progress]');
    if (progress) progress.hidden = true;
  }

  function showDropzone(buyEl) {
    const dz = $(buyEl, '[data-fab-cp-dropzone]');
    if (dz) dz.hidden = false;
  }

  function hideDropzone(buyEl) {
    const dz = $(buyEl, '[data-fab-cp-dropzone]');
    if (dz) dz.hidden = true;
  }

  function showPreview(buyEl, previewUrl, filename) {
    const pv = $(buyEl, '[data-fab-cp-preview]');
    if (!pv) return;
    pv.hidden = false;
    const img = $(buyEl, '[data-fab-cp-preview-img]');
    if (img) img.src = previewUrl;
    const name = $(buyEl, '[data-fab-cp-preview-name]');
    if (name) name.textContent = filename || 'Your photo';
  }

  function hidePreview(buyEl) {
    const pv = $(buyEl, '[data-fab-cp-preview]');
    if (pv) pv.hidden = true;
  }

  function showAtc(buyEl) {
    const atc = $(buyEl, '[data-fab-cp-atc-area]');
    if (atc) atc.hidden = false;
  }

  function hideAtc(buyEl) {
    const atc = $(buyEl, '[data-fab-cp-atc-area]');
    if (atc) atc.hidden = true;
  }

  function showPdpOptions(sectionEl) {
    sectionEl.querySelectorAll('[data-fab-cp-pdp-options]').forEach((el) => {
      el.hidden = false;
    });
  }

  function hidePdpOptions(sectionEl) {
    sectionEl.querySelectorAll('[data-fab-cp-pdp-options]').forEach((el) => {
      el.hidden = true;
    });
  }

  function showPostUploadMessage(buyEl) {
    const m = $(buyEl, '[data-fab-cp-post-upload-message]');
    if (m) m.hidden = false;
  }

  function hidePostUploadMessage(buyEl) {
    const m = $(buyEl, '[data-fab-cp-post-upload-message]');
    if (m) m.hidden = true;
  }

  function hasActiveUpload(buyEl) {
    const uploadInput = $(buyEl, '[data-fab-cp-prop-upload-id]');
    return !!(uploadInput && uploadInput.value && !uploadInput.disabled);
  }

  function setHiddenProp(buyEl, attr, value) {
    const input = $(buyEl, `[${attr}]`);
    if (!input) return;
    if (value) {
      input.value = value;
      input.disabled = false;
    } else {
      input.value = '';
      input.disabled = true;
    }
  }

  function showError(buyEl, message) {
    const notice = $(buyEl, '[data-fab-cp-notice]');
    if (notice) {
      const txt = $(buyEl, '[data-fab-cp-notice-text]') || notice;
      txt.textContent = message;
      notice.hidden = false;
      setTimeout(() => { notice.hidden = true; }, 6000);
    } else {
      alert(message);
    }
  }

  function revokeCropPreview(sectionEl) {
    if (sectionEl._fabCpCropObjectUrl) {
      URL.revokeObjectURL(sectionEl._fabCpCropObjectUrl);
      sectionEl._fabCpCropObjectUrl = null;
    }
  }

  function cpSectionRoot(sectionEl) {
    return sectionEl.closest('product-info') || sectionEl;
  }

  function stickyBarMockup(sectionEl) {
    const bar = cpSectionRoot(sectionEl).querySelector('[data-product-sticky-cart-bar]');
    return bar ? bar.querySelector('[data-fab-cp-sticky-mockup]') : null;
  }

  function readStickyMockupState(buyEl, sectionEl, photoUrlOverride) {
    if (!photoUrlOverride && !hasActiveUpload(buyEl)) return null;

    const previewInput = $(buyEl, '[data-fab-cp-prop-preview-url]');
    const uploadInput = $(buyEl, '[data-fab-cp-prop-upload-id]');
    const orientInput = $(buyEl, '[data-fab-cp-prop-orientation]');
    const frameInput = $(buyEl, '[data-fab-cp-prop-frame-code]');

    let frameCode = frameInput && frameInput.value ? frameInput.value : '';
    if (!frameCode && window.FabCpGallery) {
      frameCode = window.FabCpGallery.frameCodeFromPicker(cpSectionRoot(sectionEl)) || '';
    }

    const previewUrl = photoUrlOverride || (previewInput ? previewInput.value : '');
    if (!previewUrl) return null;

    return {
      uploadId: uploadInput ? uploadInput.value : '',
      previewUrl,
      orientation: orientInput && orientInput.value ? orientInput.value : 'portrait',
      frameCode: frameCode || 'black',
    };
  }

  function syncStickyBarMockup(sectionEl, buyEl, photoUrlOverride) {
    const mockup = stickyBarMockup(sectionEl);
    if (!mockup) return;

    const state = readStickyMockupState(buyEl, sectionEl, photoUrlOverride);
    if (!state) {
      mockup.hidden = true;
      return;
    }

    mockup.dataset.uploadId = state.uploadId;
    mockup.dataset.previewUrl = state.previewUrl;
    mockup.dataset.orientation = state.orientation;
    mockup.dataset.frameCode = state.frameCode;
    mockup.hidden = false;
    mockup.dataset.fabCpMockupReady = '';

    if (window.FabCpCartMockup) {
      window.FabCpCartMockup.initAll(cpSectionRoot(sectionEl));
    }
  }

  function hideStickyBarMockup(sectionEl) {
    const mockup = stickyBarMockup(sectionEl);
    if (mockup) mockup.hidden = true;
  }

  function applyBlobToGallery(sectionEl, buyEl, getGallery, blob, orientation) {
    if (!blob) return null;
    revokeCropPreview(sectionEl);
    const url = URL.createObjectURL(blob);
    sectionEl._fabCpCropObjectUrl = url;
    const gallery = getGallery();
    if (gallery) {
      if (gallery.setPhotoUrl) gallery.setPhotoUrl(url);
      if (gallery.setOrientation && orientation) gallery.setOrientation(orientation);
    }
    syncStickyBarMockup(sectionEl, buyEl, url);
    return url;
  }

  function resetGalleryPhoto(sectionEl, buyEl, getGallery) {
    const galleryEl = sectionEl.querySelector('fab-gallery[data-fab-cp-gallery]');
    const placeholder = galleryEl && galleryEl.dataset.initialPhotoUrl;
    const gallery = getGallery();
    if (gallery && placeholder && gallery.setPhotoUrl) {
      gallery.setPhotoUrl(placeholder);
    }
    hideStickyBarMockup(sectionEl);
  }

  function bindGallery(sectionEl) {
    const gallery = sectionEl.querySelector('fab-gallery[data-fab-cp-gallery]');
    if (gallery && gallery._fabCpGallery) return gallery._fabCpGallery;
    if (gallery && window.FabCpGallery) {
      gallery._fabCpGallery = new window.FabCpGallery(gallery);
      return gallery._fabCpGallery;
    }
    return null;
  }

  function syncGalleryFrame(sectionEl, getGallery) {
    const gallery = getGallery();
    if (!gallery || !gallery.setFrameCode || !window.FabCpGallery) return;
    const code = window.FabCpGallery.frameCodeFromPicker(sectionEl);
    if (code) gallery.setFrameCode(code);
  }

  async function blobToFile(blob, name) {
    return new File([blob], name || 'photo.jpg', { type: blob.type || 'image/jpeg' });
  }

  function init(sectionEl) {
    if (sectionEl._fab_cp_inited) return;
    sectionEl._fab_cp_inited = true;

    const buyEl = sectionEl.querySelector('[data-fab-cp-buy]');
    if (!buyEl) return;

    const fileInput = $(buyEl, '[data-fab-cp-file-input]');
    const dropTarget = $(buyEl, '[data-fab-cp-dropzone-target]');
    const replaceBtn = $(buyEl, '[data-fab-cp-replace]');
    const removeBtn = $(buyEl, '[data-fab-cp-remove]');
    const libraryEl = $(buyEl, '[data-fab-cp-library]');
    const libraryTrack = $(buyEl, '[data-fab-cp-library-track]');

    const library = window.FabCpLibrary ? new window.FabCpLibrary() : null;

    let galleryRef = null;
    const getGallery = () => {
      if (galleryRef) return galleryRef;
      galleryRef = bindGallery(sectionEl);
      return galleryRef;
    };

    bindGallery(sectionEl);
    syncGalleryFrame(sectionEl, getGallery);

    function renderLibrary() {
      if (!library || !libraryTrack) return;
      library.reload();
      const items = library.list();
      if (!items.length) {
        if (libraryEl) libraryEl.hidden = true;
        libraryTrack.innerHTML = '';
        return;
      }
      if (libraryEl) libraryEl.hidden = false;
      const activeId = library.getActiveId();

      libraryTrack.innerHTML = '';
      items.forEach((item) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'fab-cp-library__item' + (item.id === activeId ? ' is-active' : '');
        btn.setAttribute('data-fab-cp-library-select', item.id);
        btn.setAttribute('role', 'listitem');
        btn.setAttribute('aria-label', item.name || 'Saved photo');
        btn.setAttribute('aria-current', item.id === activeId ? 'true' : 'false');

        const img = document.createElement('img');
        img.src = item.thumbDataUrl || '';
        img.alt = '';
        btn.appendChild(img);

        const del = document.createElement('button');
        del.type = 'button';
        del.className = 'fab-cp-library__delete';
        del.setAttribute('data-fab-cp-library-delete', item.id);
        del.setAttribute('aria-label', 'Delete photo');
        del.textContent = '×';
        btn.appendChild(del);

        libraryTrack.appendChild(btn);
      });

      const addBtn = document.createElement('button');
      addBtn.type = 'button';
      addBtn.className = 'fab-cp-library__item fab-cp-library__item--add';
      addBtn.setAttribute('data-fab-cp-library-add', '');
      addBtn.setAttribute('aria-label', 'Add photo');
      addBtn.textContent = '+';
      libraryTrack.appendChild(addBtn);
    }

    function stampFrameCode() {
      if (!hasActiveUpload(buyEl)) return;
      const pickerRoot = cpSectionRoot(sectionEl);
      const frameCode =
        window.FabCpGallery && window.FabCpGallery.frameCodeFromPicker
          ? window.FabCpGallery.frameCodeFromPicker(pickerRoot)
          : '';
      if (!frameCode) return;
      setHiddenProp(buyEl, 'data-fab-cp-prop-frame-code', frameCode);
    }

    async function persistCartPreview(uploadId, blob) {
      if (!uploadId || !blob || !library) return;
      try {
        await library.saveCartPreview(uploadId, blob);
      } catch (_) { /* ignore */ }
    }

    function clearFormProps() {
      setHiddenProp(buyEl, 'data-fab-cp-prop-upload-id', '');
      setHiddenProp(buyEl, 'data-fab-cp-prop-preview-url', '');
      setHiddenProp(buyEl, 'data-fab-cp-prop-orientation', '');
      setHiddenProp(buyEl, 'data-fab-cp-prop-frame-code', '');
      setHiddenProp(buyEl, 'data-fab-cp-prop-crop-box', '');
    }

    function clearActiveUi() {
      sectionEl._fabCpActiveLibraryId = null;
      sectionEl._fabCpLastFile = null;
      revokeCropPreview(sectionEl);
      resetGalleryPhoto(sectionEl, buyEl, getGallery);
      hidePreview(buyEl);
      hidePostUploadMessage(buyEl);
      hideAtc(buyEl);
      hidePdpOptions(sectionEl);
      hideProgress(buyEl);
      showDropzone(buyEl);
      clearFormProps();
      if (library) library.setActiveId(null);
      renderLibrary();
    }

    async function applyLibraryRecord(record, previewBlob) {
      if (!record || !previewBlob) return;
      sectionEl._fabCpActiveLibraryId = record.id;
      sectionEl._fabCpLastFile = await blobToFile(previewBlob, record.name);
      library.setActiveId(record.id);

      const displayUrl = applyBlobToGallery(sectionEl, buyEl, getGallery, previewBlob, record.orientation);
      hideDropzone(buyEl);
      hideProgress(buyEl);
      showPreview(buyEl, displayUrl || record.thumbDataUrl, record.name);

      if (record.uploadId) {
        setHiddenProp(buyEl, 'data-fab-cp-prop-upload-id', record.uploadId);
        setHiddenProp(buyEl, 'data-fab-cp-prop-preview-url', record.previewUrl || '');
        setHiddenProp(buyEl, 'data-fab-cp-prop-orientation', record.orientation || '');
        setHiddenProp(buyEl, 'data-fab-cp-prop-crop-box', record.cropBox ? JSON.stringify(record.cropBox) : '');
        stampFrameCode();
        syncStickyBarMockup(sectionEl, buyEl);
        persistCartPreview(record.uploadId, previewBlob);
        showPostUploadMessage(buyEl);
        showAtc(buyEl);
        showPdpOptions(sectionEl);
      } else {
        clearFormProps();
        hidePostUploadMessage(buyEl);
        hideAtc(buyEl);
        hidePdpOptions(sectionEl);
      }

      renderLibrary();
    }

    async function activateLibraryItem(id) {
      if (!library || !id) return;
      const meta = library.getMeta(id);
      const blob = await library.getPreviewBlob(id);
      if (!meta || !blob) {
        await library.remove(id);
        renderLibrary();
        if (library.getActiveId() === id) clearActiveUi();
        return;
      }
      await applyLibraryRecord(meta, blob);
    }

    async function deleteLibraryItem(id) {
      if (!library || !id) return;
      const wasActive = sectionEl._fabCpActiveLibraryId === id || library.getActiveId() === id;
      const nextActive = await library.remove(id);
      renderLibrary();
      if (wasActive) {
        if (nextActive) {
          await activateLibraryItem(nextActive);
        } else {
          clearActiveUi();
        }
      }
    }

    if (libraryTrack) {
      libraryTrack.addEventListener('click', (e) => {
        const delBtn = e.target.closest('[data-fab-cp-library-delete]');
        if (delBtn) {
          e.preventDefault();
          e.stopPropagation();
          const id = delBtn.getAttribute('data-fab-cp-library-delete');
          if (id) deleteLibraryItem(id);
          return;
        }
        const addTile = e.target.closest('[data-fab-cp-library-add]');
        if (addTile) {
          e.preventDefault();
          if (fileInput) {
            fileInput.value = '';
            sectionEl._fabCpForceNewLibrary = true;
            fileInput.click();
          }
          return;
        }
        const selectBtn = e.target.closest('[data-fab-cp-library-select]');
        if (selectBtn) {
          e.preventDefault();
          const id = selectBtn.getAttribute('data-fab-cp-library-select');
          if (id) activateLibraryItem(id);
        }
      });
    }

    const fabConfig = window.fab || {};
    if (!fabConfig.uploadEndpoint || !fabConfig.statusEndpoint || !fabConfig.supabaseAnonJwt) {
      console.error('[fab-cp] missing window.fab config');
    }

    async function handleFile(file, opts) {
      opts = opts || {};
      if (!file) return;
      sectionEl._fabCpLastFile = file;

      if (!SUPPORTED_MIME.includes(file.type.toLowerCase())) {
        showError(buyEl, 'Please choose a JPG, PNG, HEIC, or WebP image.');
        return;
      }
      if (file.size > MAX_ORIGINAL_BYTES) {
        showError(buyEl, 'That image is over 25MB. Please choose a smaller file.');
        return;
      }
      if (!window.FabCpCropper) {
        showError(buyEl, 'Couldn\'t open the cropper. Please reload and try again.');
        return;
      }

      const cropper = new window.FabCpCropper({});
      let cropResult;
      try {
        cropResult = await cropper.open(file);
      } catch (err) {
        if (err && err.message === 'upload_new') {
          fileInput.value = '';
          fileInput.click();
        }
        return;
      }

      hideDropzone(buyEl);
      const cropDisplayUrl = applyBlobToGallery(sectionEl, buyEl, getGallery, cropResult.blob, cropResult.orientation);
      showProgress(buyEl, 'Uploading your photo…', 10);

      if (!window.FabCpUploader) {
        showError(buyEl, 'Upload module not loaded. Please reload and try again.');
        showDropzone(buyEl);
        hideProgress(buyEl);
        return;
      }

      const uploader = new window.FabCpUploader({
        uploadEndpoint: fabConfig.uploadEndpoint,
        statusEndpoint: fabConfig.statusEndpoint,
        supabaseAnonJwt: fabConfig.supabaseAnonJwt,
        onProgress(p) {
          const labels = {
            hashing: 'Preparing your photo…',
            uploading: 'Uploading…',
            screening: 'Reviewing your photo…',
            done: 'Done',
          };
          showProgress(buyEl, labels[p.phase] || 'Working…', p.pct);
        },
      });

      try {
        const result = await uploader.upload({
          originalFile: file,
          previewBlob: cropResult.blob,
          previewWidth: cropResult.width,
          previewHeight: cropResult.height,
          orientation: cropResult.orientation,
          cropBox: cropResult.crop_box,
        });

        hideProgress(buyEl);
        showPreview(buyEl, cropDisplayUrl || cropResult.dataUrl, file.name);
        showPostUploadMessage(buyEl);
        showAtc(buyEl);
        showPdpOptions(sectionEl);

        const gallery = getGallery();
        if (gallery && gallery.setOrientation) {
          gallery.setOrientation(cropResult.orientation);
        }
        if (result.preview_url && gallery && gallery.setPhotoUrl) {
          const probe = new Image();
          probe.onload = () => {
            if (probe.naturalWidth === cropResult.width && probe.naturalHeight === cropResult.height) {
              gallery.setPhotoUrl(result.preview_url);
              revokeCropPreview(sectionEl);
              syncStickyBarMockup(sectionEl, buyEl, result.preview_url);
            }
          };
          probe.src = result.preview_url;
        }

        setHiddenProp(buyEl, 'data-fab-cp-prop-upload-id', result.upload_id);
        setHiddenProp(buyEl, 'data-fab-cp-prop-preview-url', result.preview_url);
        setHiddenProp(buyEl, 'data-fab-cp-prop-orientation', cropResult.orientation);
        setHiddenProp(buyEl, 'data-fab-cp-prop-crop-box', JSON.stringify(cropResult.crop_box));
        stampFrameCode();
        syncStickyBarMockup(sectionEl, buyEl);
        persistCartPreview(result.upload_id, cropResult.blob);

        if (library) {
          const saveId = opts.replaceActive ? sectionEl._fabCpActiveLibraryId : null;
          const record = await library.save({
            id: saveId || undefined,
            name: file.name,
            orientation: cropResult.orientation,
            cropBox: cropResult.crop_box,
            uploadId: result.upload_id,
            previewUrl: result.preview_url,
            previewBlob: cropResult.blob,
          });
          sectionEl._fabCpActiveLibraryId = record.id;
          sectionEl._fabCpLastFile = await blobToFile(cropResult.blob, file.name);
          renderLibrary();
        }

      } catch (err) {
        hideProgress(buyEl);
        revokeCropPreview(sectionEl);
        resetGalleryPhoto(sectionEl, buyEl, getGallery);
        showDropzone(buyEl);
        const msg = err && err.message === 'rejected_screening'
          ? 'We can\'t print this image. Please choose another photo.'
          : (err && err.message === 'screening_timeout'
            ? 'Review took too long. Please try uploading again.'
            : (err && String(err.message || '').includes('blocked_by_proxy')
              ? 'Upload was blocked by our CDN. Please try again in a moment.'
              : 'Something went wrong with the upload. Please try again.'));
        showError(buyEl, msg);
      }
    }

    function bindGalleryEdit() {
      const galleryEl = sectionEl.querySelector('fab-gallery[data-fab-cp-gallery]');
      if (!galleryEl || galleryEl._fabCpEditBound) return;
      galleryEl._fabCpEditBound = true;
      galleryEl.addEventListener('fab-cp-gallery:edit', () => {
        if (sectionEl._fabCpLastFile) {
          handleFile(sectionEl._fabCpLastFile, { replaceActive: true });
          return;
        }
        if (fileInput) {
          fileInput.value = '';
          fileInput.click();
        }
      });
    }

    bindGalleryEdit();

    const productInfo = sectionEl.closest('product-info') || sectionEl;
    productInfo.addEventListener('variant:change', () => {
      syncGalleryFrame(productInfo, getGallery);
      if (hasActiveUpload(buyEl)) {
        stampFrameCode();
        syncStickyBarMockup(sectionEl, buyEl);
      }
    });

    const productForm = sectionEl.querySelector('form[data-type="add-to-cart-form"]') || sectionEl.querySelector('product-form form');
    if (productForm && !productForm._fabCpSubmitBound) {
      productForm._fabCpSubmitBound = true;
      productForm.addEventListener('submit', () => {
        if (hasActiveUpload(buyEl)) {
          stampFrameCode();
        }
      });
    }

    const stickySubmit = cpSectionRoot(sectionEl).querySelector('[data-sticky-cart-submit]');
    if (stickySubmit && !stickySubmit._fabCpSubmitBound) {
      stickySubmit._fabCpSubmitBound = true;
      stickySubmit.addEventListener('click', () => {
        if (hasActiveUpload(buyEl)) {
          stampFrameCode();
        }
      }, true);
    }

    if (fileInput) {
      fileInput.addEventListener('change', () => {
        const f = fileInput.files && fileInput.files[0];
        if (f) {
          const forceNew = sectionEl._fabCpForceNewLibrary;
          sectionEl._fabCpForceNewLibrary = false;
          const replaceActive = !forceNew && !!sectionEl._fabCpActiveLibraryId;
          handleFile(f, { replaceActive });
        }
      });
    }

    if (dropTarget) {
      dropTarget.addEventListener('dragover', (e) => {
        e.preventDefault();
        dropTarget.classList.add('is-dragover');
      });
      dropTarget.addEventListener('dragleave', () => {
        dropTarget.classList.remove('is-dragover');
      });
      dropTarget.addEventListener('drop', (e) => {
        e.preventDefault();
        dropTarget.classList.remove('is-dragover');
        const f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (f) handleFile(f, { replaceActive: !!sectionEl._fabCpActiveLibraryId });
      });
    }

    if (replaceBtn) {
      replaceBtn.addEventListener('click', () => {
        fileInput.value = '';
        fileInput.click();
      });
    }

    if (removeBtn) {
      removeBtn.addEventListener('click', () => {
        const activeId = sectionEl._fabCpActiveLibraryId;
        if (activeId && library) {
          deleteLibraryItem(activeId);
        } else {
          clearActiveUi();
        }
      });
    }

    renderLibrary();
    if (library && library.list().length) {
      const items = library.list();
      const activeId = library.getActiveId() || items[0].id;
      activateLibraryItem(activeId);
    } else {
      clearActiveUi();
    }
  }

  function bootAll() {
    document.querySelectorAll('[data-fab-cp-section]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
})();
